package model

import utils.*
import utils.ff.Companion.giEmpresa
import utils.ff.Companion.println0


open class Padrao {

    var PAD_CODIGO = 0
    var PAD_SITUAC = ""

    var PAD_TELA = ""
    var PAD_CONTEUDO = ""

    fun ini(CODIGO: Int, SITUAC: String): Padrao {

        this.PAD_CODIGO = CODIGO
        this.PAD_SITUAC = SITUAC

        return this
    }

    fun construtorLista(_it: String): List<Padrao> {

        //o retorno vem sempre entre aspas "OK"
        println0("@Investigar construtorListaPadrao _it = ${_it.uppercase().trim()}")
        var iLinha = 0
        val lObj = ArrayList<Padrao>()
        if (_it.equals("")) {
            val o = Padrao()
            o.PAD_CODIGO = 200
            o.PAD_SITUAC = "Não houve resposta do servidor, aparenta ter executado, confira!"
            lObj.add(o)
        } else if (_it.uppercase().trim().ffCopy(2,_it.length-2) == "OK") {
            println0("@Investigar entrou no OK")
            val o = Padrao()
            o.PAD_CODIGO = 200
            o.PAD_SITUAC = "Ok"
            lObj.add(o)
        } else {
            if ((!_it.equals(null)) && (!_it.equals(""))) {
                val it = if (_it.ffCopy(0, 1).equals("[")) _it else "[$_it]"
                //val lista = JSON.parse<Array<Produto>>(it.responseText)
                val lista = JSON.parse<Array<dynamic>>(it)

                lista.forEach {
                    val o = Padrao()
                    o.PAD_CODIGO = it.PAD_CODIGO.toString().ffVsi()
                    o.PAD_SITUAC = it.PAD_SITUAC.toString()
                    o.PAD_TELA = it.PAD_TELA.toString()
                    o.PAD_CONTEUDO = it.PAD_CONTEUDO.toString()

                    lObj.add(o)
                }
            }
        }

        //msgAviso("Gravado 11")
        println0("@Investigar construtorListaPadrao lObj = $lObj")
        return lObj
    }

    fun getProdutoLoteCount(cb: (String) -> Unit) {
        //var sTeste = "${ff.gsDom1}/produtolote/014_2/empresa"
        //var sTeste = "http://10.10.1.32:8080/AdmRet-1/res/produtolote/014_2/1"
        Service().getString("produtolote/014_2/$giEmpresa/30") { _sRetorno ->
            val obj = construtorLista(_sRetorno)
            cb(obj.get(0).PAD_SITUAC)
        }
    }

}

